import {Client} from '../../../graphql/types'

const AFFILIATE_IDS = [36688, 36694, 36706, 36707, 36708, 36712, 36717, 36771, 36745,36869, 36873, 36884, 36873, 10333]

export const overrideForAffiliates = (accounts: any[], client: Client) => {
  if (!client.affiliateId) return accounts

  if (!AFFILIATE_IDS.includes(client.affiliateId)) return accounts

  return accounts.filter((account) => !['black', 'raw', 'mt5Raw', 'mt5Vip'].includes(account.accountSubtype))
}
